import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GungPlatformDeterminerService {
  readonly isMacOS = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
}
